// Week arithmetic for timesheets on the web (round 44). The server's
// src/timesheets/weeks.ts answers the same questions; these are the few the
// pages need before they have asked the server anything (which week is
// "this week", what to call it). Calendar dates only, never a timestamp.
import { addDays, formatDate, type DateOnly } from './dates';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const WEEKDAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

/** 0 = Sunday, the setting's numbering. */
export function dayOfWeek(date: DateOnly): number {
  const [y, m, d] = date.split('-').map(Number);
  return new Date(Date.UTC(y!, m! - 1, d!)).getUTCDay();
}

export function weekStartFor(date: DateOnly, startDow: number): DateOnly {
  return addDays(date, -((dayOfWeek(date) - startDow + 7) % 7));
}

/** 'Mon 06/10/2026' (round 45: every date reads DD/MM/YYYY). */
export function dayLabel(date: DateOnly): string {
  return `${DAYS[dayOfWeek(date)]} ${formatDate(date)}`;
}

/** 'Monday' */
export function weekdayName(date: DateOnly): string {
  return WEEKDAY_NAMES[dayOfWeek(date)]!;
}

/** '06/10/2026 to 12/10/2026', the server's wording. No dash: customers read it. */
export function weekLabel(weekStart: DateOnly): string {
  return `${formatDate(weekStart)} to ${formatDate(addDays(weekStart, 6))}`;
}

/** 7:30 as '7:30am', the product's clock (lib/dates formatClock). */
export function clock(time: string | null): string {
  if (!time) return '';
  const hours = Number(time.slice(0, 2));
  const minutes = time.slice(3, 5);
  const suffix = hours < 12 ? 'am' : 'pm';
  const h = hours % 12 === 0 ? 12 : hours % 12;
  return `${h}:${minutes}${suffix}`;
}
